export default __webpack_public_path__ + "static/media/closeBlack.64b29b0d.svg";